import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import { withStyles } from '@material-ui/core/styles'

import Button from './Button'


const style = () => ({
  root: {},
  paper: {
    color: 'white',
    background: 'rgba(0, 0, 0, 0.8)',
  },
})


const Modal = ({
  title,
  onClose,
  classes,
  children,
  onCancel,
  onSubmit,
  isLoading,
  className,
  submitLabel,
  cancelLabel,
  paperClassName,
  containerClassName,
  ...props
}) => (
  <Dialog
    classes={{
      container: containerClassName,
      paper: classNames(classes.paper, paperClassName),
    }}
    onClose={isLoading ? () => {} : onClose}
    {...props}
  >
    {title && <DialogTitle>{title}</DialogTitle>}
    <DialogContent>{children}</DialogContent>
    {(onSubmit || onCancel) && (
      <DialogActions>
        {onCancel && <Button isLoading={isLoading} onClick={onCancel} color="secondary">{cancelLabel}</Button>}
        {onSubmit && <Button isLoading={isLoading} onClick={onSubmit} color="primary">{submitLabel}</Button>}
      </DialogActions>
    )}
  </Dialog>
)


Modal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  cancelLabel: PropTypes.string,
  submitLabel: PropTypes.string,
  paperClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  classes: PropTypes.object.isRequired,
}


export default withStyles(style)(Modal)
